export const FR_FR_KICORE = {
 "catalog": {
 "6 meses": "6 mois",
 "1 año": "1 an",
 "Próximos 12 meses": "12 mois suivants",
 "El correo electrónico no es válido": "L'adresse e-mail n'est pas valide",
 "la versión": "la version",
 "publicada": "publiée",
 "Escribe la versión para confirmar": "Saisissez la version pour confirmer",
 "Es la versión en distribución: al borrarla se retira también el puntero del canal y los equipos dejarán de recibir actualizaciones desde aquí.": "C’est la version en distribution : la supprimer retire aussi le pointeur du canal, et les appareils cesseront de recevoir des mises à jour depuis ici.",
 "Se eliminará el paquete y su manifest. Los equipos que ya la tengan instalada no se ven afectados.": "Le paquet et son manifest seront supprimés. Les appareils qui l’ont déjà installée ne sont pas affectés.",
 "Destino": "Destination",
 "Sin declarar": "Non déclarée",
 "Destino de la versión": "Destination de la version",
 "Se publicó antes de declarar destino: se trata como dirigida a equipos": "Publiée avant l’existence des destinations : traitée comme destinée aux équipements",
 "Esta versión se publicó sin declarar destino, así que se trata como dirigida a equipos": "Cette version a été publiée sans destination, elle est donc traitée comme destinée aux équipements",
 "Es la versión en distribución, así que el cambio tiene efecto de inmediato": "C’est la version en distribution, le changement prend donc effet immédiatement",
 "No está en distribución: el cambio tendrá efecto cuando se publique": "Pas en distribution : le changement prendra effet lors de sa publication",
 "¿A qué va dirigido este software?": "À qui ce logiciel est-il destiné ?",
 "Equipos": "Équipements",
 "Aplicaciones de usuario": "Applications utilisateur",
 "Aplicación de usuario": "Application utilisateur",
 "Core comprueba que el equipo esté registrado y con la suscripción en regla": "Core vérifie que l'équipement est enregistré et que son abonnement est en règle",
 "Se descarga sin comprobar nada en Core, porque no hay equipo que comprobar": "Téléchargé sans aucune vérification dans Core, car il n'y a pas d'équipement à vérifier",
 "Destino del software": "Destination du logiciel",
 "Cambiar destino": "Changer la destination",
 "Destino actualizado": "Destination mise à jour",
 "Consultando el destino actual": "Consultation de la destination actuelle",
 "Dejará de comprobarse la suscripción": "L'abonnement ne sera plus vérifié",
 "Cualquiera con un token válido podrá descargar este software, sin pasar por Core.": "Toute personne disposant d’un jeton valide pourra télécharger ce logiciel, sans passer par Core.",
 "El cambio se aplica a todas las versiones publicadas de este firmware": "Le changement s’applique à toutes les versions publiées de ce firmware",
 "Gestión de versiones de firmware OTA": "Gestion des versions de firmware OTA",
 "el firmware": "le firmware",
 "el canal": "le canal",
 "la variante": "la variante",
 "la carpeta": "le dossier",
 "Eliminar definitivamente": "Supprimer définitivement",
 "Esta acción no se puede deshacer": "Cette action est irréversible",
 "Se eliminarán todas las versiones que cuelgan de esta ruta, incluidas las que estén en distribución. Los equipos dejarán de recibir actualizaciones desde aquí.": "Toutes les versions sous ce chemin seront supprimées, y compris celles en distribution. Les appareils cesseront de recevoir des mises à jour depuis ici.",
 "Se eliminará": "Sera supprimé",
 "Calculando lo que contiene": "Calcul du contenu",
 "Escribe la ruta para confirmar": "Saisissez le chemin pour confirmer",
 "Nuevo firmware": "Nouveau firmware",
 "Nuevo canal": "Nouveau canal",
 "Nueva variante": "Nouvelle variante",
 "Nueva versión": "Nouvelle version",
 "Sin versiones publicadas": "Aucune version publiée",
 "Se creará el firmware": "Le firmware sera créé",
 "Se creará el canal": "Le canal sera créé",
 "Se creará la variante": "La variante sera créée",
 "Las carpetas del almacén nacen con su primera versión": "Les dossiers du dépôt naissent avec leur première version",
 "Publicar una versión": "Publier une version",
 "Publicar": "Publier",
 "Nuevo o existente": "Nouveau ou existant",
 "Sin variante": "Sans variante",
 "Se publicará en": "Sera publié dans",
 "Esa versión ya existe en este destino": "Cette version existe déjà à cet emplacement",
 "Solo se admiten letras, números, punto, guion y guion bajo": "Seuls les lettres, chiffres, point, tiret et tiret bas sont admis",
 "Al publicarla, los equipos del canal empezarán a descargarla": "Une fois publiée, les appareils du canal commenceront à la télécharger",
 "Subiendo el paquete": "Téléversement du paquet",
 "Procesando en el servidor: checksum y manifest": "Traitement sur le serveur : checksum et manifest",
 "Quitar": "Retirer",
 "Buscar versión": "Rechercher une version",
 "Ver como tabla": "Vue tableau",
 "Ver como tarjetas": "Vue cartes",
 "Ninguna versión coincide con la búsqueda": "Aucune version ne correspond à la recherche",
 "Subir un nivel": "Remonter d’un niveau",
 "Todos los firmwares": "Tous les firmwares",
 "Variante": "Variante",
 "canal": "canal",
 "canales": "canaux",
 "variante": "variante",
 "variantes": "variantes",
 "O pulsa para elegirlo": "Ou cliquez pour le choisir",
 "versión": "version",
 "carpeta": "dossier",
 "Selecciona un firmware o un canal para ver su contenido": "Sélectionnez un firmware ou un canal pour voir son contenu",
 "Carpetas": "Dossiers",
 "Versiones": "Versions",
 "versiones": "versions",
 "carpetas": "dossiers",
 "Selecciona un canal para ver su contenido": "Sélectionnez un canal pour voir son contenu",
 "Esta carpeta solo contiene otras carpetas": "Ce dossier ne contient que d’autres dossiers",
 "Firmwares": "Firmwares",
 "Firmware": "Firmware",
 "En distribución": "En distribution",
 "Poner en distribución": "Mettre en distribution",
 "Ninguna versión en distribución": "Aucune version en distribution",
 "Eliminar y retirar de distribución": "Supprimer et retirer de la distribution",
 "Descargar": "Télécharger",
 "Publicada": "Publiée",
 "Actualizar": "Actualiser",
 "Sin firmwares publicados": "Aucun firmware publié",
 "Selecciona un canal para ver sus versiones": "Sélectionnez un canal pour voir ses versions",
 "Arrastra aquí el paquete de firmware": "Déposez ici le paquet de firmware",
 "O pulsa para elegirlo y completar los datos de la versión": "Ou cliquez pour le choisir et compléter les données de la version",
 "Un firmware o un canal nuevo nace al subir su primera versión": "Un nouveau firmware ou canal naît lors du téléversement de sa première version",
 "Variante (opcional)": "Variante (facultatif)",
 "Distingue compilaciones del mismo canal, por ejemplo rpi4": "Distingue les builds d’un même canal, par exemple rpi4",
 "Versiones de firmware": "Versions de firmware",
 "Firmware OTA": "Firmware OTA",
 "Carpeta": "Dossier",
 "Publicada por": "Publiée par",
 "Archivo": "Fichier",
 "Tamaño": "Taille",
 "Acciones": "Actions",
 "Marcar latest": "Marquer comme latest",
 "¿Marcar esta versión como latest?": "Marquer cette version comme latest ?",
 "Los dispositivos del canal se actualizarán a esta versión": "Les appareils du canal seront mis à jour vers cette version",
 "¿Borrar la versión latest?": "Supprimer la version latest ?",
 "Es la versión latest del canal: se borrará también el puntero": "C'est la version latest du canal : le pointeur sera également supprimé",
 "Productos": "Produits",
 "Subir versión": "Téléverser une version",
 "Versión marcada como latest": "Version marquée comme latest",
 "Versión borrada correctamente": "Version supprimée avec succès",
 "Las carpetas se crean al subir su primera versión": "Les dossiers sont créés lors du téléversement de leur première version",
 "Producto": "Produit",
 "Canal": "Canal",
 "Target (opcional)": "Cible (facultatif)",
 "Subcarpeta para diferenciar builds, por ejemplo rpi4": "Sous-dossier pour différencier les builds, par exemple rpi4",
 "Campo obligatorio": "Champ obligatoire",
 "Seleccionar archivo": "Sélectionner un fichier",
 "Marcar como latest": "Marquer comme latest",
 "Formato no permitido": "Format non autorisé",
 "Selecciona el archivo de firmware": "Sélectionnez le fichier de firmware",
 "Versión subida correctamente": "Version téléversée avec succès",
 "Subir": "Téléverser",
 "Caducidad suscripción": "Expiration de l’abonnement",
 "Cambiar tarifa": "Changer le tarif",
 "Selecciona la tarifa destino para las tarjetas seleccionadas": "S\u00e9lectionnez le tarif de destination pour les cartes s\u00e9lectionn\u00e9es", 
 "Selecciona tarjetas y una tarifa": "S\u00e9lectionnez des cartes et un tarif", 
 "Algunas tarjetas no se pudieron actualizar": "Certaines cartes n'ont pas pu \u00eatre mises \u00e0 jour", 
 "Actualizadas": "Mises \u00e0 jour", 
 "Fallidas": "\u00c9checs", 
"Error 404": "Erreur 404", 
 "Detalles Administrativos": "D\u00e9tails administratifs", 
 "Detalles  M2M": "D\u00e9tails M2M", 
 "Search": "Rechercher", 
 "Reset": "R\u00e9initialisation", 
 "Instalaci\u00f3n/Pedido": "Appareil/Commande", 
 "Cliente": "Client", 
 "Estado": "\u00c9tat", 
 "Desactivada": "D\u00e9sactiv\u00e9", 
 "Activada": "Activ\u00e9", 
 "Inactiva nueva": "Inactif nouveau", 
 "Lista para activaci\u00f3n": "Pr\u00eat pour l'activation", 
 "Desconocido": "Inconnue", 
 "Consumo diario": "Consommation quotidienne", 
 "Consumo mensual": "Consommation mensuelle", 
 "Comienzo \u00faltima conexi\u00f3n": "D\u00e9marrer la derni\u00e8re connexion", 
 "Fin \u00faltima conexi\u00f3n": "Fin de la derni\u00e8re connexion", 
 "Compa\u00f1\u00eda de red": "Entreprise de r\u00e9seau", 
 "C\u00f3digo de pa\u00eds": "Code postal", 
 "Tipo de red": "Type de r\u00e9seau", 
 "Tipo de tarifa": "Type de taux", 
 "Zona 1": "Zone 1", 
 "Sin asignar": "Non attribu\u00e9", 
 "Cambiar ciclo vida": "Changer la dur\u00e9e de vie du cycle", 
 "Por favor, seleccione una opci\u00f3n": "Veuillez s\u00e9lectionner une option", 
 "Desactivar": "D\u00e9sactiver", 
 "Activar": "Activer", 
 "Test": "Test", 
 "Estado GSM": "Statut GSM", 
 "Estado GPRS": "Statut GPRS", 
 "Buscar": "Chercher", 
 "Borrar": "Effacer", 
 "Nombre": "Nom", 
 "Descripci\u00f3n": "La description", 
 "UUID placa": "UUID plaque", 
 "Estado instalaci\u00f3n": "\u00c9tat de l'installation", 
 "Desconectada": "D\u00e9branch\u00e9", 
 "Conectada": "Connect\u00e9", 
 "Deshabilitada": "D\u00e9sactiv\u00e9", 
 "Habilitada": "Activ\u00e9", 
 "Detalles": "Des d\u00e9tails", 
 "No se pudieron actualizar los datos": "\u00c9chec de la mise \u00e0 jour des donn\u00e9es", 
 "Pools actualizados correctamente": "Pools mis \u00e0 jour avec succ\u00e8s", 
 "Tarjetas activas / tarjetas totales": "Cartes actives / Nombre total de cartes", 
 "Consumo del pool / Pool total": "Consommation piscine / Piscine totale", 
 "Gasto estimado del pool": "Estimation des d\u00e9penses du pool", 
 "\u00daltima actualizaci\u00f3n": "Derni\u00e8re mise \u00e0 jour", 
 "Refrescar": "Rafra\u00eechir", 
 "Actualizar token de acceso": "Actualiser le jeton d'acc\u00e8s", 
 "Por favor, complete este campo": "Veuillez remplir ce champ", 
 "Enviar": "Envoyer", 
 "Placa creada correctamente": "Plaque cr\u00e9\u00e9e avec succ\u00e8s", 
 "Placa actualizada correctamente": "Plaque mise \u00e0 jour avec succ\u00e8s", 
 "MAC err\u00f3nea": "Mauvais MAC", 
 "SSID err\u00f3neo": "Mauvais SSID", 
 "Nuevo kiwi": "Nouveau kiwi", 
 "Informaci\u00f3n de kiwi": "Infos sur les kiwis", 
 "Guardar": "Sauvegarder", 
 "UUID err\u00f3neo": "Mauvais UUID", 
 "Nuevo kibox": "Nouveau kibox", 
 "Informaci\u00f3n de kibox con UUID": "Informations Kibox avec UUID", 
 "Informaci\u00f3n de kibox": "Informations Kibox", 
 "Habr\u00e1 mas de una placa con ese uuid.\u00bfEst\u00e1 seguro de esto?": "Il y aura plus d'une plaque avec cet uuid. \u00cates-vous s\u00fbr de cela?", 
 "Modelo placa": "Mod\u00e8le de plaque", 
 "Seleccionar opci\u00f3n": "S\u00e9lectionner l'option", 
 "Tarda demasiado en encenderse": "Prend trop de temps \u00e0 s'allumer", 
 "Usuario": "Utilisateur", 
 "Nombre de usuario": "Nom d'utilisateur", 
 "Rol": "R\u00f4le", 
 "Organizaci\u00f3n": "Organisation", 
 "Apellidos": "Le nom", 
 "Email": "Email", 
 "Complete los campos obligatorios": "Remplissez les champs obligatoires", 
 "Las contrase\u00f1as tienen que ser iguales": "Les mots de passe doivent \u00eatre identiques", 
 "Nombre de Usuario": "Nom d'utilisateur", 
 "Correo electr\u00f3nico": "Courrier \u00e9lectronique", 
 "Contrase\u00f1a": "Mot de passe", 
 "Repetir contrase\u00f1a": "R\u00e9p\u00e9ter le mot de passe", 
 "Selecciona organizaci\u00f3n": "S\u00e9lectionnez l'organisation", 
 "Nivel": "Niveau", 
 "Selecciona un rol": "S\u00e9lectionnez un r\u00f4le", 
 "Superadministrador": "Super administrateur", 
 "Administrador": "Administrateur", 
 "Operador": "Op\u00e9rateur", 
 "Visitante": "Visiteur", 
 "Activo": "Actif", 
 "Crear cuenta": "Cr\u00e9er un compte", 
 "Inicio": "D\u00e9but", 
 "Nuevo equipo": "Nouvelle \u00e9quipe", 
 "Stock": "Stocker", 
 "Asignaciones": "Affectations", 
 "Lista equipos": "Liste des appareils", 
 "Instalaciones": "L' appareil", 
 "Listado M2M": "R\u00e9f\u00e9rencement M2M", 
 "Listado Pools": "Liste de pool", 
 "Soporte": "Soutien", 
 "Crear Usuario": "Cr\u00e9er un utilisateur", 
 "Lista Usuarios": "Liste d'utilisateur", 
 "error": "Erreur", 
 "Informaci\u00f3n de tarjeta M2M con icc": "Informations sur la carte M2M avec ICC", 
 "Alias": "Alias", 
 "Life Cycle Status": "\u00c9tat du cycle de vie", 
 "Pais": "Pays", 
 "Plan": "Plan", 
 "Estado Actual": "\u00c9tat actuel", 
 "\u00daltimo evento": "Dernier \u00e9v\u00e9nement", 
 "Tecno.Conexi\u00f3n": "Techno.Connexion", 
 "\u00daltima Conexi\u00f3n": "Derni\u00e8re connexion", 
 "Complete los campos": "Remplissez les champs", 
 "Inicio de sesi\u00f3n exitoso": "Connexion r\u00e9ussie", 
 "Introduzca un nombre de usuario": "Entrez un nom d'utilisateur", 
 "Introduzca una contrase\u00f1a": "Entrer un mot de passe", 
 "Iniciar sesi\u00f3n": "Commencer la session", 
 "Eliminar": "\u00c9liminer", 
 "Editar": "Modifier", 
 "Asignar": "Attribuer", 
 "N\u00famero de serie err\u00f3neo": "Mauvais num\u00e9ro de s\u00e9rie", 
 "Nuevo KiWi": "Nouveau kiwi", 
 "Pedido": "Commande", 
 "N serie": "S\u00e9rie N", 
 "Fecha fabricaci\u00f3n": "Date de fabrication", 
 "Estado de fabricaci\u00f3n": "Statut de fabrication", 
 "KiWi terminado": "Kiwi fini", 
 "No se ha podido terminar": "N'a pas pu finir", 
 "Terminar": "Finir", 
 "Version hardware": "Version mat\u00e9rielle", 
 "Modelo": "Mod\u00e8le", 
 "Tipo USB": "Type USB", 
 "Instalaci\u00f3n": "L' appareil", 
 "Cliente kiconex": "Client kiconex", 
 "Cliente final": "Client final", 
 "N\u00famero de serie": "Num\u00e9ro de s\u00e9rie", 
 "kiconex plan": "Forfait Kiconex", 
 "Nº dispositivos": "Nombre d'appareils", 
 "Cuadro": "Cadre", 
 "Placa terminada": "Assiette finie", 
 "Opcionales": "Optionnel", 
 "Notas": "Notes", 
 "Crear nuevo dispositivo": "Cr\u00e9er un nouvel appareil", 
 "Bienvenido a kicore ¡la plataforma de gesti\u00f3n de Kiconex!": "Bienvenue sur kicore, la plateforme de gestion de Kiconex !", 
 "Ver en kiconex": "Voir dans kiconex", 
 "ICC err\u00f3neo": "ICC mauvais", 
 "Nombre instalaci\u00f3n": "Nom de l'appareil", 
 "Nº serie": "Num\u00e9ro de s\u00e9rie", 
 "Versi\u00f3n hardware": "Version mat\u00e9rielle", 
 "Ninguno": "Rien", 
 "Chino": "C", 
 "Basic": "Basic", 
 "Professional": "Proffesional", 
 "Premium": "Premium", 
 "No": "Ne pas", 
 "S\u00ed": "Oui", 
 "Cable": "C\u00e2ble", 
 "Fabricado": "Fabriqu\u00e9", 
 "Asignado": "Attribu\u00e9", 
 "Terminado": "Achev\u00e9e", 
 "Eliminado": "Supprim\u00e9", 
 "Volver": "Revenir", 
 "Plan kiconex": "Kiconex plan", 
 "¡MAC err\u00f3nea!": "Mauvais MAC!", 
 "Introduzca una MAC o IMEI v\u00e1lidos": "Entrez un MAC ou un IMEI valide", 
 "Generar UUID": "G\u00e9n\u00e9rer l'UUID", 
 "¡SSID err\u00f3neo!": "Mauvais SSID!", 
 "¡UUID err\u00f3neo!": "Mauvais UUID!", 
 "¡ICC err\u00f3neo!": "Mauvais ICC!", 
 "¡N\u00famero de serie err\u00f3neo!": "Mauvais num\u00e9ro de s\u00e9rie!", 
 "Grupo comercial": "Groupe commercial", 
 "Habilitaci\u00f3n": "Activation", 
 "F\u00e1brica": "Usine", 
 "Administraci\u00f3n": "Administration", 
 "Gesti\u00f3n": "Gestion", 
 "Usuarios": "Utilisateurs", 
 "Lista kibox": "Kibox liste", 
 "Lista kiwi": "Kiwi liste", 
 "Kibox asignados": "Kibox attribu\u00e9es", 
 "Kiwis asignados": "Kiwi attribu\u00e9", 
 "No se conecta al WiFi": "Ne se connecte pas au WiFi", 
 "Este pedido debe salir con una pegatina extra": "Cette commande doit sortir avec un autocollant suppl\u00e9mentaire", 
 "Cambiar estado de la SIM": "Changer l'\u00e9tat de la carte SIM", 
 "Estado de la SIM": "\u00c9tat de fabrication", 
 "Fruter\u00eda fulanito": "Exemple de magasin de fruits", 
 "Token actualizado correctamente": "Jeton mis \u00e0 jour avec succ\u00e8s", 
 "Usuario creado correctamente": "Utilisateur cr\u00e9\u00e9 avec succ\u00e8s", 
 "No hay respuesta del servidor": "Il n'y a pas de r\u00e9ponse du serveur", 
 "Error": "Erreur", 
 "Error al cerrar sesi\u00f3n": "\u00c9chec de la d\u00e9connexion", 
 "Seleccionar idioma": "S\u00e9lectionner une langue", 
 "Espa\u00f1ol": "Espagnol", 
 "Ingl\u00e9s": "Anglais", 
 "Franc\u00e9s": "Fran\u00e7ais", 
 "Alem\u00e1n": "Allemand", 
 "UUID": "UUID", 
 "Nombre comercial": "Nom commercial", 
 "Pedido comercial": "Commande commerciale", 
 "N\u00famero de serie comercial": "Num\u00e9ro de s\u00e9rie commerciale", 
 "Modelo del equipo": "Mod\u00e8le d'\u00e9quipement", 
 "Estado Comercial": "Statut Commercial", 
 "Fecha Conexi\u00f3n": "Date de connexion", 
 "Subscripci\u00f3n": "abonnement", 
 "Comercial": "Commercial", 
 "General": "G\u00e9n\u00e9ral", 
 "Placa borrada correctamente": "Plaque effac\u00e9e avec succ\u00e8s", 
 "Sistema": "Syst\u00e8me", 
 "Privilegios": "Privil\u00e8ges", 
 "Roles": "Les r\u00f4les", 
 "Usuario borrado correctamente": "Utilisateur supprim\u00e9 avec succ\u00e8s", 
 "Cambiar contrase\u00f1a": "Changer le mot de passe", 
 "Columnas": "Colonnes", 
 "Sin informaci\u00f3n": "Aucune information", 
 "Cerrar": "Fermer", 
 "Cambiar": "Changer", 
 "Por favor, seleccione una opcion": "Veuillez s\u00e9lectionner une option", 
 "¡Las contrase\u00f1as deben coincidir!": "¡Les mots de passe doivent correspondre!", 
 "La contrase\u00f1a es un campo obligatorio": "Mot de passe est un champ obligatoire", 
 "success": "succ\u00e8s", 
 "Contrase\u00f1a actualizada correctamente": "Mot de passe mis \u00e0 jour avec succ\u00e8s", 
 "Las contrase\u00f1as deben coincidir": "Les mots de passe doivent correspondre", 
 "Cambio de contrase\u00f1a usuario": "Changement de mot de passe utilisateur", 
 "Debe seleccionar un rol": "Vous devez s\u00e9lectionner un r\u00f4le", 
 "Rol creado correctamente": "R\u00f4le cr\u00e9\u00e9 avec succ\u00e8s", 
 "Nuevo Rol": "Nouveau R\u00f4le", 
 "Informaci\u00f3n de Rol": "Informations sur le R\u00f4le", 
 "Rol borrado correctamente": "R\u00f4le supprim\u00e9 avec succ\u00e8s", 
 "Rol administrador": "R\u00f4le d'administrateur", 
 "Sincronizar": "Synchroniser", 
 "¡Sincronizar datos!": "¡Synchroniser les donn\u00e9es!", 
 "Nombre, Organizaci\u00f3n y subscripci\u00f3n van a ser modificados por el valor que tengan en la plataforma Kiconex \u00bfEst\u00e1 seguro de esto?": "Le nom, l'organisation et l'abonnement seront modifi\u00e9s par la valeur qu'ils ont dans la plate-forme Kiconex. \u00cates-vous s\u00fbr de cela ?", 
 "Usuario guardado correctamente": "Utilisateur enregistr\u00e9 avec succ\u00e8s", 
 "Nuevo usuario": "Nouvel utilisateur", 
 "Editando usuario": "Modifier l'utilisateur", 
 "Software": "Logiciel", 
 "Crear": "Cr\u00e9er", 
 "Ver": "Regarder", 
 "Finalizar": "Finir", 
 "Editar comercial": "Modifier la publicit\u00e9", 
 "Gesti\u00f3n de placas de f\u00e1brica": "Gestion des plaques d'immatriculation d'usine", 
 "Asignaciones de f\u00e1brica": "Affectations d'usine", 
 "Asignaci\u00f3n de placas de f\u00e1brica": "Attribution des plaques d'usine", 
 "Gesti\u00f3n de placas de administraci\u00f3n": "Direction du conseil d'administration", 
 "mykiconex": "mykiconex", 
 "Gesti\u00f3n con plataforma mykiconex": "Gestion avec la plateforme mykiconex", 
 "M2M": "M2M", 
 "Ver M2M": "Voir M2M", 
 "Ver estado": "Afficher l'\u00e9tat", 
 "Ver listado pools": "Voir la liste des pools", 
 "Refrescar pools": "Rafra\u00eechir les piscines", 
 "Actualizar token": "Jeton d'actualisation", 
 "VPN": "VPN", 
 "Chat": "Chat", 
 "Ver privilegios": "Afficher les privil\u00e8ges", 
 "Editar privilegios": "Modifier les privil\u00e8ges", 
 "Gesti\u00f3n de sistema": "La gestion du syst\u00e8me", 
 "Gesti\u00f3n de usuarios": "Gestion des utilisateurs", 
 "Ver acceso a chat": "Afficher l'acc\u00e8s au chat", 
 "Ver acceso a soporte": "Voir l'acc\u00e8s au support", 
 "Ver acceso a VPN": "Voir l'acc\u00e8s VPN", 
 "Gesti\u00f3n de tarjetas M2M": "Gestion des cartes M2M", 
 "Autorizaci\u00f3n": "Autorisation", 
 "Portugu\u00e9s": "Portugais", 
 "Italiano": "Italien", 
 "Fecha primera contrataci\u00f3n": "Premi\u00e8re date d'embauche", 
 "Fecha \u00faltima renovaci\u00f3n": "Derni\u00e8re date de renouvellement", 
 "Intervalo de renovaci\u00f3n (a\u00f1os)": "Intervalle de renouvellement (ann\u00e9es)", 
 "Fecha primera conexi\u00f3n": "Premi\u00e8re date de connexion", 
 "Privilegios guardados correctamente": "Privil\u00e8ges enregistr\u00e9s correctement", 
 "Rol actualizado correctamente": "R\u00f4le mis \u00e0 jour correctement", 
 "N\u00famero Pedido": "Num\u00e9ro de commande", 
 "Asunto": "Affaire", 
 "Asignado a": "Assign\u00e9 \u00e0", 
 "Fecha de Creaci\u00f3n": "Date de creation", 
 "Pendiente": "En attente", 
 "Cambiar Estado": "Changer le statut", 
 "Estado del Pedido actualizado correctamente": "Commandez l'\u00e9tat mis \u00e0 jour correctement", 
 "Cliente Final": "Client final", 
 "Referencia Presupuesto": "R\u00e9f\u00e9rence budg\u00e9taire", 
 "Precio Total": "Prix ​​total", 
 "Ver en CRM": "Voir dans CRM", 
 "N\u00famero Presupuesto": "Num\u00e9ro de budget", 
 "En Proceso": "En proc\u00e8s", 
 "Anulado": "Annul\u00e9", 
 "Cambiar estado del pedido": "Modifier l'\u00e9tat de la commande", 
 "Pedidos": "Ordres", 
 "Gesti\u00f3n de pedidos": "Gestion des commandes", 
 "Error en la operaci\u00f3n": "Erreur de fonctionnement", 
 "UUID de placa ya en uso": "UUID de plaque d\u00e9j\u00e0 utilis\u00e9", 
 "Nueva Placa Guardada": "Nouvelle assiette sauv\u00e9e", 
 "Placa actualizada": "Assiette mise \u00e0 jour", 
 "Placa borrada": "Assiette supprim\u00e9e", 
 "Placas actualizadas": "Plaques mises \u00e0 jour", 
 "SSID de kiwi ya en uso": "Kiwi ssid d\u00e9j\u00e0 utilis\u00e9", 
 "Nuevo KiWi Guardado": "Nouveau kiwi sauv\u00e9", 
 "KiWi actualizado": "Kiwi mis \u00e0 jour", 
 "KiWi borrado": "Kiwi supprim\u00e9", 
 "Token actualizado": "Jeton mis \u00e0 jour", 
 "Nombre de rol ya en uso": "Nom du r\u00f4le d\u00e9j\u00e0 utilis\u00e9", 
 "Rol actualizado": "R\u00f4le mis \u00e0 jour", 
 "No puede eliminar un rol con dependencias": "Ne peut pas \u00e9liminer un r\u00f4le avec les d\u00e9pendances", 
 "La clave ha expirado.": "La cl\u00e9 a expir\u00e9.", 
 "Usuario no encontrado.": "Utilisateur non trouv\u00e9.", 
 "Las contrase\u00f1as son obligatorias.": "Les mots de passe sont obligatoires.", 
 "Las contrase\u00f1as no coinciden.": "Les mots de passe ne correspondent pas.", 
 "Nombre de usuario ya en uso": "Nom d'utilisateur d\u00e9j\u00e0 utilis\u00e9", 
 "Error del servidor.": "Erreur du serveur.", 
 "El usuario no ha sido activado.": "L'utilisateur n'a pas \u00e9t\u00e9 activ\u00e9.", 
 "Inicio de sesi\u00f3n con \u00e9xito": "Connexion r\u00e9ussie", 
 "Contrase\u00f1a incorrecta": "Mot de passe incorrect", 
 "Fecha Renovaci\u00f3n": "Date de renouvellement", 
 "Tiempo Restante": "Temps Restant", 
 " meses restantes": " mois restants", 
 "Pedidos a expirar": "Ordres d'expirer", 
 "Descargar Informe": "Rapport de t\u00e9l\u00e9chargement", 
 "Renovaciones": "R\u00e9novations", 
 "Pr\u00f3ximo mes": "Mois prochain", 
 "Pr\u00f3ximos 3 meses": "3 mois suivants", 
 "Pr\u00f3ximos 6 meses": "6 mois suivants", 
 "Pr\u00f3ximo a\u00f1o": "L'ann\u00e9e prochaine", 
 "Ver renovaciones": "Voir les r\u00e9novations", 
 "Caducada": "Expir\u00e9", 
 " d\u00edas restantes": " jours restants", 
 "Aceptar": "Accepter", 
 "Reiniciar": "Red\u00e9marrage", 
 "Sin organizaci\u00f3n": "Aucune organisation", 
 "Ver pools": "Voir les pools", 
 "Alarmas": "Alarmes", 
 "Alarmas M2M": "Alarmes M2M", 
 "Sin alertas": "Sans alerte", 
 "Advertencia": "Avertissement", 
 "Critica": "Critique", 
 "Renovaciones expiradas": "R\u00e9novations expir\u00e9es", 
 "Pedidos pendientes": "Les ordres en attente", 
 "Tarjetas desactivadas desde hace mas de 12 meses": "Cartes d\u00e9sactiv\u00e9es pendant plus de 12 mois", 
 "Ver m\u00e1s": "Voir plus", 
 "Creaci\u00f3n": "Cr\u00e9ation", 
 "Actualizaci\u00f3n": "Actualisation", 
 "Borrado": "Effac\u00e9", 
 "Cambio de estado": "Changement de statut", 
 "Cambio de contrase\u00f1a": "Changement de mot de passe", 
 "Sincronizaci\u00f3n": "Synchronisation", 
 "Sin acci\u00f3n": "Pas d'action", 
 "Fecha": "Date", 
 "Acci\u00f3n": "Action", 
 "Tipo de objeto": "Type d'objet", 
 "Identificador": "Identifiant", 
 "Placa": "Plaque", 
 "Hace 3 horas": "il y a 3 heures", 
 "Hace 1 d\u00eda": "il y a 1 jour", 
 "Hace 3 d\u00edas": "Il y \u00e0 3 jours", 
 "Hace 1 semana": "Il ya 1 semaine", 
 "Actividad": "Activit\u00e9", 
 "Listado": "Liste", 
 "Ver actividad": "Voir l'activit\u00e9", 
 "Privilegio": "Privil\u00e8ge", 
 "No es posible personificar desde un personificado.": "Il n'est pas possible de personnifier \u00e0 partir d'un personnifi\u00e9.", 
 "Personificaci\u00f3n": "Personnification", 
 "Personificando al usuario": "Personcifier l'utilisateur", 
 "Volver a la sesi\u00f3n": "Aller \u00e0 la session", 
 "Personificar": "Personnifier", 
 "No es posible personificarse a si mismo.": "Il n'est pas possible de vous personnifier.", 
 "Comienzo Personificaci\u00f3n": "D\u00e9but Personnification", 
 "Fin Personificaci\u00f3n": "Fin de personnification", 
 "Ajustes": "Param\u00e8tres", 
 "Actualizar listado": "Liste de mise \u00e0 jour", 
 "Refrescar pedidos": "Rafra\u00eechir les commandes", 
 "Refrescar ordenes de trabajo": "Rafra\u00eechir les ordres de travail", 
 "de": "de", 
 "filtrados de": "filtr\u00e9", 
 "Actualizar listado de organizaciones": "Mettre \u00e0 jour la liste des organisations", 
 "Actualizar nombre, plan y organizaci\u00f3n de kibox": "Mettre \u00e0 jour le nom, le plan et l'organisation de Kibox", 
 "Actualizar listado de pedidos": "Mettre \u00e0 jour la liste des commandes", 
 "Actualizar listado de ordenes de trabajo": "Mettre \u00e0 jour la liste des ordres de travail", 
 "Actualizaci\u00f3n de listados": "Liste de mise \u00e0 jour", 
 "Actualizado con exito": "Mis \u00e0 jour avec succ\u00e8s", 
 "Activa": "Actif", 
 "Sin intervalo": "Pas d'intervalle", 
 "Mostrar todo": "Tout montrer", 
 "Estado de suscripci\u00f3n no compatible con el intervalo seleccionado": "\u00c9tat d'abonnement non compatible avec l'intervalle s\u00e9lectionn\u00e9", 
 "Estado del plan": "Statut de plan", 
 "Caducado": "Fin du temps", 
 "Inactivo": "Inactif", 
 "Cancelado": "Annul\u00e9", 
 "No procede": "Il ne continue pas", 
 "¡Orden de trabajo erronea!": "Ordre de travail erron\u00e9!", 
 "Rellene el formulario correctamente": "Remplissez correctement le formulaire", 
 "Orden de trabajo": "Ordre de travail", 
 "Su sesi\u00f3n va a ser cerrada": "Votre session sera ferm\u00e9e", 
 "Su sesi\u00f3n se cerrar\u00e1 para aplicar los cambios": "Vous serez d\u00e9connect\u00e9 pour appliquer les modifications", 
 "Inicie sesi\u00f3n de nuevo": "Connectez-vous \u00e0 nouveau", 
 "Posee una versi\u00f3n no compatible": "Il a une version non compatible", 
 "Consumo": "Consommation", 
 "Consumo de la SIM": "Consommation SIM", 
 "Mensual": "Mensuel", 
 "Diario": "Agenda", 
 "UUID ya en uso": "UUID d\u00e9j\u00e0 utilis\u00e9", 
 "VPN creada correctamente": "VPN cr\u00e9\u00e9 avec succ\u00e8s", 
 "VPN actualizada correctamente": "VPN mis \u00e0 jour avec succ\u00e8s", 
 "Contrase\u00f1a copiada al portapapeles": "Mot de passe copi\u00e9 dans le presse-papiers", 
 "Fallo al copiar la contrase\u00f1a": "\u00c9chec de la copie du mot de passe", 
 "Nueva conexi\u00f3n VPN": "Nouvelle connexion VPN", 
 "Regenerar contrase\u00f1a": "R\u00e9g\u00e9n\u00e9rer le mot de passe", 
 "Contrase\u00f1a VPN": "Mot de passe VPN", 
 "Copie la contrase\u00f1a antes de guardar, no volver\u00e1 a ser visible": "Copiez le mot de passe avant de l'enregistrer, il ne sera plus visible", 
 "VPN (antigua)": "VPN (ancien)", 
 "Ver acceso a VPN (antigua)": "Afficher l'acc\u00e8s VPN (ancien)", 
 "Ver VPN (antigua)": "Voir VPN (ancien)", 
 "Ver VPN": "Voir VPN", 
 "Crear VPN": "Cr\u00e9er un VPN", 
 "Editar VPN": "Modifier le VPN", 
 "Ver informaci\u00f3n": "Voir les informations", 
 "Informaci\u00f3n placas": "Informations sur la plaque", 
 "Modelo de hardware": "Mod\u00e8le de mat\u00e9riel", 
 "Fecha de compilaci\u00f3n": "Date de construction", 
 "Versi\u00f3n de Daemon": "Version d\u00e9mon", 
 "Fecha de actualizaci\u00f3n": "Date de mise \u00e0 jour", 
 "Actualizado": "Mis \u00e0 jour", 
 "No actualizado": "Pas \u00e0 jour", 
 "Descargar fichero de configuraci\u00f3n": "T\u00e9l\u00e9charger le fichier de configuration", 
 "Nunca": "Jamais", 
 "Dispositivo": "Appareil", 
 "Router kiconex": "Routeur Kiconex", 
 "Fecha de expedici\u00f3n": "Date d'\u00e9mission", 
 "\u00bfEst\u00e1 seguro de que desea eliminar este elemento?": "\u00cates-vous s\u00fbr de vouloir supprimer cet \u00e9l\u00e9ment ?", 
 "Confirmaci\u00f3n de eliminaci\u00f3n": "Confirmation de suppression", 
 "S\u00ed, eliminar": "Oui, supprimer", 
 "Cancelar": "Annuler", 
 "Unidades de cable": "Unit\u00e9s de c\u00e2ble", 
 "En espera": "En attente", 
 "En proceso": "En cours", 
 "UUID Original": "UUID Original", 
 "El nombre es obligatorio": "Le nom est obligatoire", 
 "UUID no v\u00e1lido": "UUID non valide", 
 "API Key borrada": "Cl\u00e9 API supprim\u00e9e", 
 "La fecha de expiraci\u00f3n debe ser posterior a la fecha actual": "La date d’expiration doit \u00eatre post\u00e9rieure \u00e0 la date actuelle", 
 "Clave editada correctamente": "Cl\u00e9 modifi\u00e9e avec succ\u00e8s", 
 "Clave creada correctamente": "Cl\u00e9 cr\u00e9\u00e9e avec succ\u00e8s", 
 "Clave copiada al portapapeles": "Cl\u00e9 copi\u00e9e dans le presse-papiers", 
 "\u00bfEst\u00e1s seguro?": "\u00cates-vous s\u00fbr ?", 
 "No podr\u00e1s volver a ver esta clave API. \u00bfDeseas continuar?": "Vous ne pourrez plus consulter cette cl\u00e9 API. Souhaitez-vous continuer ?", 
 "S\u00ed, cerrar": "Oui, fermer", 
 "La clave no volver\u00e1 a estar disponible": "La cl\u00e9 ne sera plus disponible", 
 "\u00bfDeseas borrar esta clave API?": "Souhaitez-vous supprimer cette cl\u00e9 API ?", 
 "S\u00ed, borrar": "Oui, supprimer", 
 "Clave borrada correctamente": "Cl\u00e9 supprim\u00e9e avec succ\u00e8s", 
 "Sin descripci\u00f3n": "Sans description", 
 "Fecha de expiraci\u00f3n": "Date d’expiration", 
 "Editar clave API": "Modifier la cl\u00e9 API", 
 "Nueva clave API": "Nouvelle cl\u00e9 API", 
 "Copiar clave": "Copier la cl\u00e9", 
 "Clave API creada correctamente": "Cl\u00e9 API cr\u00e9\u00e9e avec succ\u00e8s", 
 "Esta es tu clave API. No podr\u00e1s volver a consultarla en el futuro, c\u00f3piala y \u00fasala donde necesites": "Voici votre cl\u00e9 API. Vous ne pourrez plus la consulter \u00e0 l’avenir, copiez-la et utilisez-la o\u00f9 n\u00e9cessaire", 
 "Claves API": "Cl\u00e9s API", 
 "Listado de claves API": "Liste des cl\u00e9s API", 
 "Generar nueva clave": "G\u00e9n\u00e9rer une nouvelle cl\u00e9", 
 "Editar claves": "Modifier les cl\u00e9s", 
 "Editar tracker": "Modifier le tracker", 
 "Modelo control": "Mod\u00e8le control", 
 "Clave API control": "Cl\u00e9 API control", 
 "Clave API box": "Cl\u00e9 API box", 
 "Actualizar claves de acceso para: ": "Mettre \u00e0 jour les cl\u00e9s d'acc\u00e8s pour : ", 
 "Traductor de librer\u00edas": "Traducteur de biblioth\u00e8ques", 
 "Estado de subscripci\u00f3n": "Statut de l'abonnement", 
 "Versi\u00f3n": "Version", 
 "Sin versi\u00f3n": "Sans version", 
 "Sin modelo": "Sans mod\u00e8le", 
 "Primero seleccione un modelo": "S\u00e9lectionnez d'abord un mod\u00e8le", 
 "Tendr\u00e1 que volver a iniciar sesi\u00f3n para usar la nueva clave": "Vous devrez vous reconnecter pour utiliser la nouvelle cl\u00e9", 
 "El nombre de usuario es un campo obligatorio": "Le nom d'utilisateur est un champ obligatoire", 
 "Pedido es un campo obligatorio": "La commande est un champ obligatoire", 
 "UUID es un campo obligatorio": "L'UUID est un champ obligatoire", 
 "Modelo y versi\u00f3n son campos obligatorios": "Le mod\u00e8le et la version sont des champs obligatoires", 
 "Renovaciones M2M expiradas": "Renouvellements M2M expir\u00e9s", 
 "Renovaciones de plan expiradas": "Renouvellements de plan expir\u00e9s", 
 "Ingrese el n\u00famero de meses": "Entrez le nombre de mois", 
 "Intervalo de renovaci\u00f3n": "Intervalle de renouvellement", 
 "suscripci\u00f3n": "abonnement", 
 "suscripciones": "abonnements", 
 "Editando": "Modification", 
 "Renovando": "Renouvellement", 
 "suscripciones actualizadas correctamente": "abonnements mis \u00e0 jour avec succ\u00e8s", 
 "Pr\u00f3xima renovaci\u00f3n": "Prochain renouvellement", 
 "Renovar": "Renouveler", 
 "\u00bfD\u00f3nde encuentro mi clave?": "O\u00f9 puis-je trouver ma cl\u00e9?", 
 "Clave API Cloud": "Cl\u00e9 API Cloud", 
 "Clave API Cloud actualizada correctamente": "Cl\u00e9 API Cloud mise \u00e0 jour avec succ\u00e8s", 
 "VPN Antigua": "Ancien VPN", 
 "Meses a renovar": "Mois \u00e0 renouveler", 
 "Debe seleccionar un estado de suscripci\u00f3n": "Vous devez s\u00e9lectionner un statut d'abonnement", 
 "Plan es obligatorio": "Le plan est obligatoire", 
 "Debe seleccionar un estado de suscripci\u00f3n M2M": "Vous devez s\u00e9lectionner un statut d'abonnement M2M", 
 "ICC es obligatorio": "ICC est obligatoire", 
 "Hist\u00f3rico de suscripci\u00f3n": "Historique de l'abonnement", 
 "Fecha de primera conexi\u00f3n": "Date de premi\u00e8re connexion", 
 "Fecha de renovaci\u00f3n": "Date de renouvellement", 
 "meses": "mois", 
 "Realizado por": "R\u00e9alis\u00e9 par", 
 "Eliminaci\u00f3n": "Suppression", 
 "Cancelaci\u00f3n": "Annulation", 
 "Preparaci\u00f3n": "Pr\u00e9paration", 
 "Cambio de intervalo": "Changement d'intervalle", 
 "Cambio de plan": "Changement de plan", 
 "Caducadas": "Expir\u00e9es", 
 "Por vencer": "\u00c0 venir", 
 "Cargando": "Chargement", 
 "Gestionar perfil": "G\u00e9rer le profil", 
 "Instalaci\u00f3n original": "Installation d'origine", 
 "Actualizar en Kite": "Mettre \u00e0 jour dans Kite", 
 "Debe seleccionar una suscripci\u00f3n de plan": "Vous devez s\u00e9lectionner un abonnement de plan", 
 "Propietario": "Propri\u00e9taire", 
 "Tarifa": "Tarif", 
 "Nueva fecha": "Nouvelle date", 
 "Error al crear usuario": "Erreur lors de la cr\u00e9ation de l'utilisateur", 
 "Error al obtener datos": "Erreur lors de la r\u00e9cup\u00e9ration des donn\u00e9es", 
 "Error al cargar las claves API": "Erreur lors du chargement des cl\u00e9s API", 
 "Error al guardar la clave": "Erreur lors de la sauvegarde de la cl\u00e9", 
 "Error al borrar la clave": "Erreur lors de la suppression de la cl\u00e9", 
 "Error al editar la clave": "Erreur lors de la modification de la cl\u00e9", 
 "Error al copiar la clave": "Erreur lors de la copie de la cl\u00e9", 
 "No puedes cambiar la fecha de expiraci\u00f3n una vez creada": "Vous ne pouvez pas modifier la date d'expiration une fois la cl\u00e9 cr\u00e9\u00e9e", 
 "No se puede devolver a Stock: la placa tiene repuestos asignados": "Impossible de retourner en Stock : la carte a des pi\u00e8ces de rechange assign\u00e9es", 
 "Introduzca su correo electr\u00f3nico": "Entrez votre adresse e-mail", 
 "Si el correo existe, recibir\u00e1 un mensaje con instrucciones para restablecer su contrase\u00f1a.": "Si l'adresse e-mail existe, vous recevrez un message avec des instructions pour r\u00e9initialiser votre mot de passe.", 
 "Enviar enlace de recuperaci\u00f3n": "Envoyer le lien de r\u00e9cup\u00e9ration", 
 "Volver al inicio de sesi\u00f3n": "Retour \u00e0 la connexion", 
 "Nueva contrase\u00f1a": "Nouveau mot de passe", 
 "Restablecer contrase\u00f1a": "R\u00e9initialiser le mot de passe", 
 "El enlace de recuperaci\u00f3n ha caducado o ya ha sido utilizado. Solicite uno nuevo.": "Le lien de r\u00e9cup\u00e9ration a expir\u00e9 ou a d\u00e9j\u00e0 \u00e9t\u00e9 utilis\u00e9. Veuillez en demander un nouveau.", 
 "Error al restablecer la contrase\u00f1a": "Erreur lors de la r\u00e9initialisation du mot de passe", 
 "\u00bfOlvid\u00f3 su contrase\u00f1a?": "Mot de passe oubli\u00e9 ?", 
 "Su contrase\u00f1a ha caducado": "Votre mot de passe a expir\u00e9", 
 "Han pasado m\u00e1s de 6 meses desde el \u00faltimo cambio. Por motivos de seguridad debe establecer una nueva contrase\u00f1a antes de continuar.": "Plus de 6 mois se sont \u00e9coul\u00e9s depuis la derni\u00e8re modification. Pour des raisons de s\u00e9curit\u00e9, vous devez d\u00e9finir un nouveau mot de passe avant de continuer.", 
 "Entendido": "Compris", 
 "La contrase\u00f1a debe tener al menos 12 caracteres.": "Le mot de passe doit comporter au moins 12 caract\u00e8res.", 
 "La contrase\u00f1a debe incluir al menos tres de las siguientes categor\u00edas: may\u00fasculas, min\u00fasculas, n\u00fameros y caracteres especiales.": "Le mot de passe doit inclure au moins trois des cat\u00e9gories suivantes : majuscules, minuscules, chiffres et caract\u00e8res sp\u00e9ciaux.", 
 "Cambiar ahora": "Changer maintenant", 
 "Su contrase\u00f1a caducar\u00e1 pronto": "Votre mot de passe expirera bient\u00f4t", 
 "Le quedan {days} d\u00edas para cambiar su contrase\u00f1a. Pulse el bot\u00f3n para hacerlo ahora.": "Il vous reste {days} jour(s) pour changer votre mot de passe. Cliquez sur le bouton pour le faire maintenant.", 
 "copiado al portapapeles": "copi\u00e9 dans le presse-papiers",
 "C\u00f3digos copiados al portapapeles": "Codes de récupération copiés dans le presse-papiers",
 "C\u00f3digos de recuperaci\u00f3n": "Codes de récupération",
 "Gu\u00e1rdelos en un lugar seguro. No se volver\u00e1n a mostrar. Cada uno sirve una sola vez si pierde el acceso a su aplicaci\u00f3n.": "Gardez-les dans un endroit sûr. Ils ne seront plus affichés. Chacun peut être utilisé une fois si vous perdez l'accès à votre application.",
 "Copiar c\u00f3digos": "Copier les codes",
 "Introduzca el c\u00f3digo": "Entrez le code",
 "C\u00f3digo incorrecto": "Code incorrect",
 "Verificaci\u00f3n en dos pasos desactivada": "Vérification en deux étapes désactivée",
 "Verificaci\u00f3n en dos pasos": "Vérification en deux étapes",
 "Introduzca uno de sus c\u00f3digos de recuperaci\u00f3n para desactivar la verificaci\u00f3n en dos pasos.": "Saisissez l'un de vos codes de récupération pour désactiver la vérification en deux étapes.",
 "C\u00f3digo de recuperaci\u00f3n": "Code de récupération",
 "Desactivar 2FA": "Désactiver la 2FA",
 "Usar el c\u00f3digo de la aplicaci\u00f3n": "Utiliser le code de l'application",
 "\u00bfNo tiene acceso a la app? Usar un c\u00f3digo de recuperaci\u00f3n": "Vous n'avez pas accès à l'application ? Utiliser un code de récupération",
 "Su cuenta est\u00e1 protegida con un segundo factor. Para desactivarlo, introduzca un c\u00f3digo de su aplicaci\u00f3n de autenticaci\u00f3n.": "Votre compte est protégé avec un deuxième facteur. Pour le désactiver, entrez un code de votre application d'authentification.",
 "\u00d1ade una capa extra de seguridad. Necesitar\u00e1 una app como Google Authenticator para generar los c\u00f3digos.": "Ajoutez une couche de sécurité supplémentaire. Vous aurez besoin d'une application comme Google Authenticator pour générer les codes.",
 "1. Escanee el c\u00f3digo QR con su aplicaci\u00f3n de autenticaci\u00f3n": "1. Scannez le code QR avec votre application d'authentification",
 "\u00bfNo puede escanear? Introduzca esta clave manualmente": "Impossible de scanner? Entrez cette clé manuellement",
 "2. Introduzca el c\u00f3digo de 6 d\u00edgitos que muestra la app": "2. Entrez le code à 6 chiffres affiché par l'application",
 "Su contrase\u00f1a ha caducado": "Votre mot de passe a expiré",
 "Error al obtener datos": "Erreur lors de la récupération des données",
 "Error al copiar": "\u00c9chec de la copie",
 "Tarifa es obligatorio": "Le tarif est obligatoire",
 "M2M actualizado correctamente": "M2M mis \u00e0 jour avec succ\u00e8s",
 "Error al actualizar M2M": "Erreur lors de la mise \u00e0 jour de M2M",
 "Enlace no v\u00e1lido o expirado. P\u00eddalo de nuevo o p\u00f3ngase en contacto con un administrador.": "Lien invalide ou expir\u00e9. Demandez-le \u00e0 nouveau ou contactez un administrateur.",
 "Datos personales": "Donn\u00e9es personnelles",
 "Seguridad y acceso": "S\u00e9curit\u00e9 et acc\u00e8s",
 "Zona horaria": "Fuseau horaire",
 "Seleccione una zona horaria": "S\u00e9lectionnez un fuseau horaire",
 "Sin instalaci\u00f3n": "Aucun appareil",
 "Cambiar clave API Cloud": "Changer la cl\u00e9 API Cloud",
 "Librerías": "Bibliothèques",
 "Plantillas": "Modèles",
 "No tiene configurada una clave API Cloud": "Vous n'avez pas de clé API Cloud configurée",
 "El traductor de librerías necesita su clave API Cloud para acceder a las librerías.": "Le traducteur de bibliothèques a besoin de votre clé API Cloud pour accéder aux bibliothèques.",
 "Configurar clave": "Configurer la clé",
 "UUID copiado al portapapeles": "UUID copié dans le presse-papiers",
 "Error al copiar el UUID": "Erreur lors de la copie de l'UUID",
 "Idioma por defecto": "Langue par défaut",
 "Traducir": "Traduire",
 "Copiar UUID": "Copier l'UUID",
 "Traducir con IA": "Traduire avec l'IA",
 "Elija un contexto para poder traducir": "Choisissez un contexte pour pouvoir traduire",
 "Parámetro": "Paramètre",
 "origen": "source",
 "librería": "bibliothèque",
 "plantilla": "modèle",
 "Contexto de traducción": "Contexte de traduction",
 "con error": "en erreur",
 "cancelando…": "annulation…",
 "pausando…": "mise en pause…",
 "en pausa": "en pause",
 "Guardar y cerrar": "Sauvegarder et fermer",
 "Traducir todo": "Tout traduire",
 "Traducir seleccionadas": "Traduire la sélection",
 "Pausar": "Mettre en pause",
 "Continuar": "Continuer",
 "El texto en el idioma origen está vacío": "Le texte dans la langue source est vide",
 "No se ha podido traducir": "La traduction a échoué",
 "Falta configurar la URL del WebSocket del traductor": "L'URL du WebSocket du traducteur n'est pas configurée",
 "No hay traducciones pendientes": "Il n'y a aucune traduction en attente",
 "No quedan traducciones pendientes": "Il ne reste aucune traduction en attente",
 "Traducción en pausa": "Traduction en pause",
 "Traducción cancelada": "Traduction annulée",
 "Traducción terminada": "Traduction terminée",
 "Error en el proceso de traducción": "Erreur dans le processus de traduction",
 "Corrija las traducciones no válidas antes de guardar": "Corrigez les traductions non valides avant de sauvegarder",
 "Traducciones guardadas": "Traductions sauvegardées",
 "No se han podido guardar las traducciones": "Impossible de sauvegarder les traductions",
 "No se han podido cargar los parámetros de la librería": "Impossible de charger les paramètres de la bibliothèque",
 "La traducción no puede superar los {max} caracteres": "La traduction ne peut pas dépasser {max} caractères",
 "La traducción contiene caracteres no válidos": "La traduction contient des caractères non valides",
 "La traducción por defecto no puede estar vacía": "La traduction par défaut ne peut pas être vide",
 "Clave API Cloud no válida": "Clé API Cloud non valide",
 "Revise su clave API Cloud para poder usar el traductor de librerías.": "Vérifiez votre clé API Cloud pour pouvoir utiliser le traducteur de bibliothèques.",
 "Revisar clave": "Vérifier la clé",
 "cambios sin guardar": "modifications non sauvegardées",
 "Acceso al traductor de librerías": "Accès au traducteur de bibliothèques",
 "sólo no válidas": "non valides uniquement",
 "No tiene permiso para modificar esta librería": "Vous n'avez pas la permission de modifier cette bibliothèque",
 "Asignar router": "Attribuer le routeur",
 "Contraseña del dispositivo": "Mot de passe de l'appareil",
 "Crear box": "Créer une box",
 "Crear router": "Créer un routeur",
 "Duplicado": "Doublon",
 "El modem ya no está disponible": "Le modem n'est plus disponible",
 "Este dispositivo no tiene ningún modem Teltonika asociado": "Cet appareil n'a aucun modem Teltonika associé",
 "Este dispositivo no tiene ningún router kiconex asignado": "Cet appareil n'a aucun routeur Kiconex attribué",
 "Exportar a Excel": "Exporter vers Excel",
 "Falta el número de serie": "Numéro de série manquant",
 "Falta la MAC": "MAC manquante",
 "Falta la contraseña": "Mot de passe manquant",
 "Fecha alta": "Date de création",
 "Fichero": "Fichier",
 "Fila": "Ligne",
 "IMEI no válido": "IMEI non valide",
 "Importar": "Importer",
 "Importar modems": "Importer des modems",
 "Información de modem": "Informations modem",
 "Información de router": "Informations routeur",
 "Libres": "Libres",
 "MAC no válida": "MAC non valide",
 "Modem": "Modem",
 "Modem Teltonika": "Modem Teltonika",
 "Modem borrado correctamente": "Modem supprimé avec succès",
 "Modem es un campo obligatorio": "Le modem est un champ obligatoire",
 "Modems importados": "Modems importés",
 "No se ha podido cargar la información del router": "Impossible de charger les informations du routeur",
 "No se ha podido leer el fichero": "Impossible de lire le fichier",
 "Nuevo modem": "Nouveau modem",
 "Nuevo repuesto": "Nouvelle pièce de rechange",
 "Nuevo router": "Nouveau routeur",
 "Observaciones": "Observations",
 "Organización es un campo obligatorio": "L'organisation est un champ obligatoire",
 "Repetido en el fichero": "Répété dans le fichier",
 "Revisa los campos marcados": "Vérifiez les champs signalés",
 "Router": "Routeur",
 "Router (dato antiguo)": "Routeur (ancienne donnée)",
 "Router borrado correctamente": "Routeur supprimé avec succès",
 "Router no disponible": "Routeur non disponible",
 "Router terminado": "Routeur achevé",
 "Seleccionar fichero": "Sélectionner le fichier",
 "Seleccionar router": "Sélectionner le routeur",
 "Sin modem Teltonika": "Sans modem Teltonika",
 "Sin tipo": "Sans type",
 "Stock Kiconex": "Stock Kiconex",
 "Stock Teltonika": "Stock Teltonika",
 "Tipo": "Type",
 "Tipo Teltonika": "Type Teltonika",
 "Tracker": "Tracker",
 "Transformados": "Transformés",
 "UUID router": "UUID du routeur",
 "Versión placa": "Version de la carte",
 "Válido": "Valide",
 "Ya existe en el sistema": "Existe déjà dans le système",
 "duplicadas": "doublons",
 "filas leídas": "lignes lues",
 "válidas": "valides",
 "¡IMEI erróneo!": "Mauvais IMEI!",
 "Lista routers": "Routeurs liste",
 "Routers asignados": "Routeurs attribués",
 "Seleccionar ICC": "Sélectionner l'ICC",
  "Se deben renovar al menos": "Il faut renouveler au moins",
},
  "plural": "(n != 1)"
  };
